import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { aboutClient } from "../apiClient/aboutClient";
import { useAuth } from "../../gym/auth/useAuth";
import type { AboutParagraph } from "../types/about.types";

export function AboutPage() {
  const { isAdmin } = useAuth();
  const [paragraphs, setParagraphs] = useState<AboutParagraph[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void aboutClient
      .getParagraphs()
      .then(setParagraphs)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load this page."))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>About Madinet Masr</h1>
        </div>
        {isAdmin && (
          <Link to="/about/admin" className="btn btn-ghost">
            Manage content
          </Link>
        )}
      </header>

      {error ? (
        <div className="state-panel">
          <p>{error}</p>
        </div>
      ) : isLoading ? (
        <div className="state-panel">Loading…</div>
      ) : (
        <div className="about-card">
          {paragraphs.map((p) => (
            <p key={p.id}>{p.text}</p>
          ))}
        </div>
      )}
    </div>
  );
}
